import { Component, Input, inject } from '@angular/core';
import { Competency } from '@app/explore/shared/menu/skills.model';
import { UserService } from '@app/user';
import { setGrow } from '../../animations/grow.animation';
import { SearchExploreService } from '../../services/search-explore.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-search-skills-categories',
    templateUrl: './search-skills-categories.component.html',
    styleUrls: ['./search-skills-categories.component.scss'],
    animations: [setGrow('0.4s', '0.4s')],
    standalone: false
})
export class SearchSkillsCategoriesComponent {
    @Input() skillCategories: Competency[];
    private readonly userService = inject(UserService);
    private readonly searchExploreService = inject(SearchExploreService);
    private readonly translateService = inject(TranslateService);

    readonly twoColumnsGridLanguages = ['fr', 'pl', 'ru'];

    readonly listId = this.searchExploreService.resultsListId;

    get hasTrial() {
        return this.userService.user.company.trial;
    }

    get hasTwoColumnGridClass() {
        return this.twoColumnsGridLanguages.includes(this.translateService.currentLang);
    }
}
